import moment from 'moment';

export type TimeDiff = {
  years: number;
  months: number;
  days: number;
  hours: number;
};

export function getTimeDiff(pastDate: Date): TimeDiff {
  const now = moment();
  const past = moment(pastDate);

  const years = now.diff(past, 'years');
  past.add(years, 'years');

  const months = now.diff(past, 'months');
  past.add(months, 'months');

  const days = now.diff(past, 'days');
  past.add(days, 'days');

  const hours = now.diff(past, 'hours');

  return {
    years: years,
    months: months,
    days: days,
    hours: hours,
  };
}

export function getRemainingTime(
  updatedAt: number,
  recoveryTimeInSeconds: number,
) {
  const updatedTime = moment(updatedAt);
  const recoveryEndTime = updatedTime.add(recoveryTimeInSeconds, 'seconds');
  const currentTime = moment();
  const remainingTime = recoveryEndTime.diff(currentTime);

  if (remainingTime <= 0) {
    return {
      timer: '00:00:00',
      isReady: true,
    };
  }

  // eslint-disable-next-line import/no-named-as-default-member
  const duration = moment.duration(remainingTime);
  const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
  const minutes = String(duration.minutes()).padStart(2, '0');
  const seconds = String(duration.seconds()).padStart(2, '0');

  return {
    timer: `${hours}:${minutes}:${seconds}`,
    isReady: false,
  };
}

export function toMs(seconds: number = 0) {
  return seconds * 1000;
}

export function toSec(ms: number = 0) {
  return ms / 1000;
}
